<template>
  <div class="c-keyboard" v-visible="!loading">
    <img class="background" :src="images.keyboard_hatsu" @load="onLoad" />
    <div class="keys">
      <template v-for="(srcKey, index) in srcKeys">
        <div
          class="key"
          :class="{
            selected: selectedIndex === index,
            changed: !disabled && false,
            disabled: srcKey.disabled,
          }"
          :key="'srcKey' + index"
          :style="srcKey.style"
          @click="
            !srcKey.disabled &&
              $emit('key-click', { index, keyIndex: srcKey.index })
          "
          @dblclick="
            !srcKey.disabled &&
              $emit('key-click', { index, keyIndex: srcKey.index })
          "
        >
          <div class="texts">
            <div
              class="text"
              v-for="(dstKey, index) in dstKeys[getKey(srcKey)]
                ? dstKeys[getKey(srcKey)].text
                : []"
              :key="'dstKey' + index"
              :style="dstKey.style"
            >
              {{ dstKey.text }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { srcKeys, dstKeys } from "./KeyboardHatsu";

export default {
  name: "CKeyboardHatsu",
  props: {
    disabled: Boolean,
    selectedIndex: Number,
    layer: Array,
  },
  data() {
    return {
      loading: true,
      srcKeys,
      dstKeys,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
  },
  methods: {
    getKey(srcKey) {
      return this.layer[srcKey.index];
    },
    onLoad() {
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-keyboard {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .keys {
    width: 98.6%;
    height: 96%;
    position: absolute;
    left: 0.7%;
    top: 0.5%;
    display: flex;
    flex-wrap: wrap;

    .key {
      width: 3.6%;
      height: 11%;
      padding: 0 0.2%;
      position: absolute;
      cursor: pointer;
      box-shadow: none;

      &.selected,
      &:hover {
        box-shadow: 0 0 0 2px $primary-color inset;
      }

      &.disabled {
        box-shadow: none;
        background-color: transparent;
        cursor: not-allowed;
      }

      .texts {
        width: 100%;
        height: 100%;
        position: relative;
        font-size: 24px;

        .text {
          width: 200%;
          text-align: left;
          position: absolute;
          left: 0;
          transform: translate(-25%, -50%) scale(0.5);
          letter-spacing: 0;
          word-break: break-all;
          line-height: 1.2;
        }
      }
    }
  }
}
</style>
